import React, {useEffect,memo} from "react";
import {Fragment, useRef, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import ComboComponent from "../comboComponent";
import {createItem, getList} from "../../services/service";
import {useSelector} from "react-redux";
import {selectUser} from "../../features/user/userSlice";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import ToggleWithLabel from "../ToggleWithLabel";


const AddParamComponent = ({open,enumType,parentId, handleClose,additionalId,getDataAfterSaveHandler,url,enumUrl,isEdit,rowId}) => {
    const cancelButtonRef = useRef(null);
    const {token} = useSelector(selectUser);
    const {t} = useTranslation();
    const [additionalParameterData, setAdditionalParameterData] = useState([]);
    const [selectedAdditionalParameterData, setSelectedAdditionalParameterData] = useState(null);
    const [list, setList] = useState([]);
    const [selectedList, setSelectedList] = useState(null)
    const [isVisible, setIsVisible] = useState(false)
    const [valueParam,setValueParam] = useState("")
    useEffect(() => {
        const getRowData = async () => {
            try{
                const response = await getList(`${process.env.REACT_APP_HOST_BASE_URL}${url}/${rowId}`,token);
                if(!response.success){
                    throw Error('Something went wrong')
                }else{
                    const findParameter = additionalParameterData.find((item)=>item?.value === response?.data[enumType] );
                    if(response?.data?.objectId || response?.data?.objectId === 0) {
                        if(findParameter) {
                            const response2 = await getList(`${process.env.REACT_APP_HOST_BASE_URL}${findParameter?.url}`, token);
                            const findItem = response2?.data.find((item) => item.id === response?.data.objectId);
                            setIsVisible(true)
                            setSelectedAdditionalParameterData(findParameter);
                            setList(response2?.data);
                            setSelectedList(findItem);
                        }
                    } else {
                        setSelectedAdditionalParameterData(findParameter);
                        setIsVisible(false);
                        setValueParam(response?.data?.value)
                    }
                }
            } catch(error) {
                console.log(error.message)
            }
        }
        if(isEdit){
            getRowData()
        } else {
            return;
        }
    },[rowId,isEdit]);

    useEffect(() => {
        const getData = async () => {
            try {
                const response = await getList(`${process.env.REACT_APP_HOST_BASE_URL}${enumUrl}`, token);
                if (!response.success) {
                    throw Error('Something went wrong !')
                } else {
                    let makeData = response?.data.map((item) => {
                        return {
                            id: item.id,
                            name: t(`${item.name}`),
                            type: item.type,
                            value: item.name,
                            url: item.url,
                        }
                    });
                    setAdditionalParameterData(makeData);
                }
            } catch (error) {
                console.log(error.message)
            }
        }
        getData();

    }, [])



    const handleComboHandler = async (value) => {
        try {
            setSelectedAdditionalParameterData(value);
            setSelectedList(null);
            setValueParam("");
            if (value?.type === 'SELECT') {
                const response = await getList(`${process.env.REACT_APP_HOST_BASE_URL}${value?.url}`, token);
                if (!response.success) {
                    throw Error('Something went wrong')
                } else {
                    let valuesData = response?.data.map((item) => {
                        return {
                            id: item.id,
                            name: t(`${item.name}`),
                            value: item.name
                        }
                    });
                    setIsVisible(true)
                    setList(valuesData)
                }
            } else if (value?.type === 'TEXT') {
                setIsVisible(false)
            } else {
                throw Error('Something went wrong')
            }
        } catch (error) {
            console.log(error.message)
        }

    };
    useEffect(()=>{
        if(isEdit === false){
            setSelectedAdditionalParameterData(null);
            setIsVisible(false);
            setList(false);
            setSelectedList(null);
            setValueParam("")
        }
    },[isEdit])

    const handleComboHandlerTwo = (value) => {
        setSelectedList(value)
        setValueParam("")
    }
    const handleChange = (e) => {
        setValueParam(e.target.value);
        setSelectedList(null)
    }
    const handleSubmit = async (e) => {
        try{
            e.preventDefault();
            const response = await createItem(`${process.env.REACT_APP_HOST_BASE_URL}${url}`,token,{
                id: rowId ? rowId : null,
                [parentId]: additionalId,
                [enumType]: selectedAdditionalParameterData.value,
                objectId:(selectedList?.id || selectedList?.id == 0) ? selectedList.id : null,
                value: valueParam ? valueParam : selectedList?.name,
            })
            if(!response.success) {
                throw Error('Something went wrong')
            }else{
                handleClose();
                getDataAfterSaveHandler();
                setSelectedAdditionalParameterData(null)
                setSelectedList(null);
                setValueParam("")
                toast.success(t('action.add_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            }
        }catch(error){
            console.log(error.message)
        }
    }
    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className="relative transform  rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                <form onSubmit={handleSubmit}>
                                    <div>
                                        <div>
                                            <ComboComponent
                                                items={additionalParameterData}
                                                selectedItem={selectedAdditionalParameterData}
                                                label={t(`parameter`)}
                                                handleComboHandler={handleComboHandler}
                                            />
                                        </div>
                                        <div>
                                            {isVisible === true ? <div className={'mt-4'}>
                                                <ComboComponent
                                                    items={list}
                                                    selectedItem={selectedList}
                                                    label={t(`value`)}
                                                    handleComboHandler={handleComboHandlerTwo}
                                                />
                                            </div> : <div className={'mt-4'}>
                                                <label htmlFor="value"
                                                       className="block text-sm font-medium leading-6 text-gray-900">
                                                    {t(`value`)}
                                                </label>

                                                <div className="mt-2">
                                                    <input
                                                        type="text"
                                                        name="value"
                                                        required
                                                        value={valueParam}
                                                        onChange={handleChange}
                                                        id="value"
                                                        autoComplete="off"
                                                        className="block w-full bg-gray-100 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:bg-white focus:ring-indigo-600 duration-200 easy-in-out sm:text-sm sm:leading-6"
                                                    />
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                    <div
                                        className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                        <button
                                            type="submit"
                                            className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2"

                                        >
                                            {t(`save`)}
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                                            onClick={handleClose}
                                            ref={cancelButtonRef}
                                        >
                                            {t(`cancel`)}
                                        </button>
                                    </div>
                                </form>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

export default memo(AddParamComponent);